import { ExpandableAccordion, MFlex } from '../../../../components/Monetize';
import { ExpandCollapseButton } from '../../../../components/Monetize/ExpandCollapseButton';
import { QuoteBodyAccordion } from '../../../../components/Quotes/QuoteBodyAccordion';
import { useExpandAllControl } from '../../../../hooks';
import { useQuoteContext } from '../../Quote/quoteContext';
import { QuoteConditionalTerms } from './QuoteConditionalTerms';
import { QuoteTerms } from './QuoteTerms';
import { QuoteUploadDocuments } from './QuoteUploadDocuments';

export const QuoteInternalExtraInfo = ({ value }: { value?: string }) => {
  const { quoteData } = useQuoteContext();
  const { quote } = quoteData;

  const {
    isAllExpanded,
    commandExpanded,
    expandCommandSeq,
    toggleExpandAll,
    onChildExpandChange,
  } = useExpandAllControl();

  if (!quote) {
    return null;
  }

  return (
    <QuoteBodyAccordion value={value} title="Documents and Terms">
      <MFlex mb={2}>
        <ExpandCollapseButton
          data-testid="documents-terms-expand-collapse-btn"
          isExpanded={isAllExpanded}
          onChange={toggleExpandAll}
        />
      </MFlex>

      <ExpandableAccordion
        isAllExpanded={commandExpanded}
        expandCommandSeq={expandCommandSeq}
        onExpandChange={onChildExpandChange}
      >
        <QuoteUploadDocuments />

        <QuoteTerms mt={6} />

        <QuoteConditionalTerms mt={6} />
      </ExpandableAccordion>
    </QuoteBodyAccordion>
  );
};
